export interface PageSEO {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
}

const SITE_URL = 'https://partnerbuddy.ai';

export { SITE_URL };

export const PAGE_SEO = {
  home: {
    title: 'PartnerBuddy - Manage AWS Partner Opportunities Where You Work',
    description:
      'PartnerBuddy brings your AWS ACE opportunities to Slack and Microsoft Teams with AI-powered natural language queries, CRM sync, and automated reporting.',
    path: '/',
  },
  features: {
    title: 'Features - PartnerBuddy',
    description:
      'Query, update, and create ACE opportunities from Slack or Teams in plain English. Proactive pipeline alerts, optional CRM sync, and built-in ACE expertise.',
    path: '/features',
  },
  support: {
    title: 'Support - PartnerBuddy',
    description:
      'Get help with PartnerBuddy. Email support, in-app help commands, and answers to frequently asked questions.',
    path: '/support',
  },
  privacy: {
    title: 'Privacy Policy - PartnerBuddy',
    description:
      'Learn how PartnerBuddy collects, uses, and protects your data. AI processing disclosure, data retention, and your privacy rights.',
    path: '/privacy',
  },
  terms: {
    title: 'Terms of Service - PartnerBuddy',
    description:
      'Terms of Service for PartnerBuddy, the AI-powered assistant for managing AWS Partner Central ACE opportunities.',
    path: '/terms',
  },
  setup: {
    title: 'Setup - PartnerBuddy',
    description: 'Configure PartnerBuddy for your workspace.',
    path: '/setup',
    noindex: true,
  },
} as const satisfies Record<string, PageSEO>;
